export const colours = {
  popup: {
    backgrounds: {
      alliance: "#3f1a1a",
      empire: "white",
      hutt: "#232d16",
      neutral: "#d6d6d6"
    },
    text: {
      alliance: "#91aeb3",
      empire: "#333",
      hutt: "#cbbfbb",
      neutral: "#252525"
    }
  }
};
